'use client';

import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../redux/actions/authActions';

// Composants importés
import Sidebar from '../common/Sidebar';
import Navbar from '../common/Navbar';
import NotificationCenter from '../common/NotificationCenter';
import ProfileNoticeModal, { isProfileNoticeDismissed } from '../common/ProfileNoticeModal';

const MainLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showProfileNotice, setShowProfileNotice] = useState(() => !isProfileNoticeDismissed());
  const { user } = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const navItems = [
    { label: 'Tableau de bord', path: '/dashboard', icon: 'dashboard' },
    { label: 'Mes soumissions', path: '/submissions', icon: 'inbox' },
    { label: 'Nouvelle soumission', path: '/submissions/new', icon: 'add' },
    { label: 'Mes commandes', path: '/orders', icon: 'shopping_cart' },
    { label: 'Mon profil', path: '/profile', icon: 'person' },
  ];

  // Ajouter des liens d'administration si l'utilisateur est admin
  if (user?.role === 'admin') {
    navItems.push({ label: 'Administration', path: '/admin', icon: 'admin_panel_settings' });
  }

  return (
    <div className="app-container">
      <Sidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        items={navItems}
        user={user}
        onLogout={handleLogout}
      />

      <div className="main-content">
        <Navbar 
          onMenuClick={toggleSidebar}
          user={user}
          onLogout={handleLogout}
        />

        <div className="page-container">
          <Outlet />
        </div>

        <NotificationCenter />

        {showProfileNotice && user?.role !== 'admin' && (
          <ProfileNoticeModal onClose={() => setShowProfileNotice(false)} />
        )}
      </div>
    </div>
  );
};

export default MainLayout;